import { RouteFactory } from "@app/routePaths";
import SMELogo from "@assets/logo-sme.svg";
import Ad from "@components/Advertisement/Ad";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";

export default function SMEBanner(): React.ReactElement {
  return (
    <>
      <div className="flex w-full flex-wrap items-center justify-center gap-2 pb-2 md:justify-between">
        <SectionMasthead
          link={RouteFactory.sgsme}
          masthead={{
            alt: "SGSME logo",
            src: SMELogo,
            width: 126,
            height: 31,
          }}
        />
      </div>
      <div className=" block h-[1px] w-full bg-gray-850 "></div>

      <Ad
        adType="lb1"
        className="flex min-h-[90px] flex-col items-center justify-center py-6"
      />
    </>
  );
}
